import React, { Component } from 'react'
import DashboardContainer from 'containers/DashboardContainer'
import * as microfrontend from 'src/actions/microfrontend'
import PropTypes from 'prop-types'
import { routerActions } from 'react-router-redux'
import { connect } from 'react-redux'
import { hasUserAccessToken } from 'services/access_tokens'
import { Skeleton } from 'antd'
import styles from './create-time-poll.scss'
const containerId = 'create-time-poll-app-id'

class CreateTimePoll extends Component {
  constructor() {
    super()
    this.controller = new AbortController()
    this.signal = this.controller.signal
    this.timer = null

    this.state = {
      isLoading: true
    }
  }

  resetComponent = () => {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    const createTimePollScript = document.getElementById(`micro-frontend-script-CreateTimePoll`)
    if (createTimePollScript) {
      document.body.removeChild(createTimePollScript)
    }
    microfrontend.unmount({ containerId })

    window.mountCreateTimePollApp = undefined
    window.unmountCreateTimePollApp = undefined
  }

  getMicroFrontendHost = () => {
    if (process.env.HEROKU_APP_NAME === 'hobnob-web-client-staging') {
      return 'https://hobnob-staging.s3.us-west-2.amazonaws.com/bundles/static'
    }
    if (process.env.HEROKU_APP_NAME === 'hobnob-web-client') {
      return 'https://hobnob-production.s3.us-west-1.amazonaws.com/bundles/static'
    }

    return 'https://hobnob-staging.s3.us-west-2.amazonaws.com/bundles/static'
  }

  componentDidMount() {
    if (!hasUserAccessToken()) {
      this.props.onNavigationLogin()
      return
    }

    const mountComponent = async () => {
      try {
        await microfrontend.render({
          containerId,
          constructorSuffix: 'CreateTimePoll',
          // host: 'https://diego-reyes-testing-bucket-21-feb.s3.amazonaws.com'
          host: this.getMicroFrontendHost(),
          signal: this.signal
        })
        this.setState({ isLoading: false })
      } catch (e) {
        console.error('Render microFrontEnd', e)
      }
    }
    mountComponent()
  }

  componentWillUnmount() {
    if (this.controller) {
      this.controller.abort()
    }
    this.resetComponent()
  }

  renderSkeleton() {
    return (
      <div className={styles['skeleton-container']}>
        <div className={styles['skeletons']}>
          <section>
            <Skeleton.Button active block />
            <Skeleton.Button active />
          </section>
          <section>
            <Skeleton.Button active block />
            <Skeleton.Button active block />
            <Skeleton.Button active block />
          </section>
        </div>
      </div>
    )
  }

  render() {
    return (
      <DashboardContainer>
        <div className={styles['time-poll-container']}>
          <div id={containerId} />
          {this.state.isLoading && this.renderSkeleton()}
        </div>
      </DashboardContainer>
    )
  }
}

CreateTimePoll.propTypes = {
  onNavigationLogin: PropTypes.func
}

function mapDispatchToProps(dispatch) {
  return {
    onNavigationLogin: () =>
      dispatch(routerActions.push({ pathname: '/login', state: { prevRoute: '/tp/create' } }))
  }
}

export default connect(null, mapDispatchToProps)(CreateTimePoll)
